
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ReferentielDTO } from 'src/app/shared/dtos/referentielDTO';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';
import { TrieTabService } from 'src/app/shared/services/utilities/trie-tab.service';
import { GestionReferentielComponentService } from '../gestion-referentiel-component.service';
import { TypeCompModel } from 'src/app/shared/models/simple-types/type-comp.model';
import { TypeCompService } from 'src/app/shared/services/simple/type-comp.service';
import { ModalInfoOkComponent } from 'src/app/shared/components/modals/info-ok/modal-info-ok.component';
import { SimpleQueryResponse } from 'src/app/shared/dtos/simpleQueryResponse';
import { ModalAddTypeCompComponent } from 'src/app/shared/components/modals/modal-add-type-comp/modal-add-type-comp.component';

@Component({
  selector: 'app-gestion-type-comp',
  templateUrl: './gestion-type-comp.component.html',
  styleUrls: ['./gestion-type-comp.component.scss']
})
export class GestionTypeCompComponent{

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();
  idSociete: number;
  mySubscription: any;
  result = false;
  loading = false;
  selectedAction: TypeCompModel;
  displayedColumns: string[] = ['code', 'libelle', 'action'];
  dataSource: TypeCompModel[];
  matDataSource = new MatTableDataSource<TypeCompModel>();
  pageEvent: PageEvent;
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageIndex: number;
  pageSize = 25;
  typeComps: TypeCompModel[] = [];
  droitLevel = 0;
  objet: SimpleQueryUser = new SimpleQueryUser();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private comp: TrieTabService,
    private typeCompService: TypeCompService,
    private toastrService: ToastrService,
    private gestionReferentielComponent: GestionReferentielComponentService
  )
  {
    this.idSociete = 1;
    this.objet.query = '';
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.objet.order = 'libelle';
    this.matDataSource.paginator = this.paginator;
    this.loadPage();
  }

  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateTypeCompFormGroup();
    const dialogRef = this.dialog.open(ModalAddTypeCompComponent, {
      autoFocus: false,
      disableClose: true,
      data: {
        form,
        typeComps: this.typeComps,
        result: this.result
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.onUpdated.emit(true);
      if (result) {
        this.loadPage();
      }
    });
  }

  onModify(typeComp: TypeCompModel): void {
    const form = this.gestionReferentielComponent.getEditTypeCompFormGroup(typeComp);
    const dialogRef = this.dialog.open(ModalAddTypeCompComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form: form,
          typeComp: this.typeComps,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });
  }


  onDelete(typeComp: TypeCompModel): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Suppression du type de complément',
        message: 'Êtes-vous sur de vouloir supprimer le type de complément ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.typeCompService.delete(typeComp.id).subscribe((response: TypeCompModel) => {
          this.toastrService.success('Le type de complément a bien été supprimé');
          this.loadPage();
        });
      }
    });
  }

  orderUsers(typeComps: TypeCompModel[]): TypeCompModel[] {
    typeComps = typeComps.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return typeComps;
  }


  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    referentiel.idSociete = this.idSociete;
    this.typeCompService.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<TypeCompModel>) => {
      if (query.objets != null) {
        this.typeComps = query.objets;
      } else {
        this.typeComps = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<TypeCompModel>(this.typeComps);
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }

}


